import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { routes } from '../../../../constants';
import { AddMenuButton } from '../MuiCardBase/MuiCardBase';
import CardCover from '../MuiCardBase/MuiCardBaseCover';
import CardContainer from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortContainer';
import CardContentWrapper from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortContentWrapper';
import CardDescription from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortDescription';
import CardDetails from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortDetails';
import CardHeaderWithTitle from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortHeaderWithTitle';
import CardMainContent from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortMainContent';
import CardMetadata from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortMetadata';
import ShowLessButton from '../MuiCardBase/MuiCardBaseShort/MuiCardBaseShortShowLessButton';
import { type CourseMuiCardProps, PublisherMetadata, ThemeMetadata } from './CourseMuiCard';
import CourseRegistrationStatus from './CourseRegistrationStatus';
import { courseTypeToPresentationNameMap, joinAuthorNames } from './utils';

export const CourseMuiShortCard: React.FC<CourseMuiCardProps> = ({
	id,
	contentType,
	publisher,
	index,
	cover,
	title,
	description,
	isPinned,
	isNew,
	itemData,
	course,
	isFirstElement,
}) => {
	const { t } = useTranslation();
	const [isTruncated, setIsTruncated] = useState(true);
	const toggleTruncated = () => setIsTruncated(!isTruncated);

	const itemLink: string = `/${routes.courseCatalog.root}/${id}`;
	const authorNames = joinAuthorNames(course.authors);

	return (
		<CardContainer contentType={contentType} isNew={isNew} isTruncated={isTruncated}>
			<AddMenuButton
				isPinned={isPinned}
				type={contentType}
				id={id}
				itemData={itemData}
				index={index}
				isFirstElement={isFirstElement}
			/>
			<CardMainContent>
				<CardCover
					contentType={contentType}
					itemLink={itemLink}
					cover={cover}
					withPlayIcon
					isTruncated={isTruncated}
					title={title}
				>
					<CourseRegistrationStatus registrationStatus={course.registrationStatus} />
				</CardCover>
				<CardContentWrapper isTruncated={isTruncated}>
					<CardHeaderWithTitle
						header={courseTypeToPresentationNameMap[course.type]}
						title={title}
						caption={authorNames}
						itemLink={itemLink}
						isTruncated={isTruncated}
					/>
					<CardMetadata isTruncated={isTruncated} toggleTruncated={toggleTruncated}>
						<span>
							{course.duration} {t('Minutes')}
						</span>
					</CardMetadata>
				</CardContentWrapper>
			</CardMainContent>
			{!isTruncated && (
				<>
					<ShowLessButton toggleTruncated={toggleTruncated} />
					<CardDescription description={description} />
					<CardDetails>
						<ThemeMetadata theme={course.theme} />
						<PublisherMetadata publisher={publisher} />
					</CardDetails>
				</>
			)}
		</CardContainer>
	);
};

export default CourseMuiShortCard;
